import React, { useState, useEffect } from 'react';
import Button from './Button';

interface MigrationToastProps {
  onDismiss: () => void;
}

const MigrationToast: React.FC<MigrationToastProps> = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the toast after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(onDismiss, 300); // Wait for animation to complete
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 animate-in slide-in-from-top-2 duration-300">
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg shadow-lg p-4 max-w-sm">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <span className="text-green-600 dark:text-green-400 text-lg">✅</span>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-green-900 dark:text-green-100">
              Data Migrated Successfully
            </h3>
            <p className="text-sm text-green-700 dark:text-green-300 mt-1">
              Your game progress from the previous version has been imported.
            </p>
          </div>
        </div>
        <div className="mt-3 flex justify-end">
          <Button
            variant="secondary"
            size="sm"
            onClick={handleDismiss}
            className="text-green-700 dark:text-green-300 hover:bg-green-100 dark:hover:bg-green-800"
          >
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MigrationToast;
